import { render, staticRenderFns } from "./PageContentForm.vue?vue&type=template&id=399e8ce8"
import script from "./PageContentForm.vue?vue&type=script&lang=ts"
export * from "./PageContentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports